module.exports = __webpack_public_path__ + "img/tabbed-search-filter-ford.95167769.png";